export default {
  'Custom': 'Personalizzato',
  'Original': 'Originale',
  'Resolution': 'Risoluzione',
  'Frame rate': 'velocità in fotogrammi',
  'The higher the frame rate, the smoother the animation': "La velocità in fotogrammi più alto, l'animazione è più fluida.",
  'Start': 'Inizio',
  'End': 'Fine',
  'Create GIF': 'Crea GIF',
  'Download GIF': 'Download GIF',
  'Create A New One': 'Creane Uno Nuovo',
  'Remake GIF': 'Crea GIF di Nuovo',
  'HitPaw Video to GIF Online': 'HitPaw Video in GIF Online',
  'Upload and convert video to GIF without any difficulty': 'Carica e converti video in GIF senza alcuna difficoltà',
}